import objectPath from 'object-path'
import { getCurrentUi } from 'designer/component/action/Data'

const getRuleUpdateValueTarget = (action = {}, target = '') => {
  return (
    target ||
    action.target ||
    action.targetKey ||
    action.key ||
    action.valueKey ||
    action.targetName ||
    action.targetOptionValue ||
    action.formDataKey ||
    ''
  )
}

const getRuleUpdateValueStatus = (status = {}) => {
  let { isDynamic, dynamicName, dynamicKey, dynamicIndex } = status

  return {
    isDynamic,
    dynamicName,
    dynamicKey,
    dynamicIndex,
  }
}

const updateRuleWidgetValue = (
  formData = {},
  ui = {},
  listItem,
) => {
  let mapWidgetUi = objectPath.get(ui, 'widget.schema.mapFormData') || {}
  let filterFormWidget = Object.keys(mapWidgetUi).filter(
    (key) => mapWidgetUi[key],
  )
  let value

  filterFormWidget.forEach((key) => {
    let widgetJsonForm = objectPath.get(ui, 'widget.jsonForm') || {}
    let widgetUi = getCurrentUi(
      key,
      widgetJsonForm.schema,
      widgetJsonForm.uischema,
    )
    let { name } = widgetUi
    value = listItem
      ? objectPath.get(listItem, name)
      : objectPath.get(formData, name)
    objectPath.set(formData, key, value)
    objectPath.set(formData, name, value)
  })

  return value
}

export const onRuleUpdateValue = (
  designContext = {},
  action = {},
  status = {},
  target = '',
) => {
  let {
    jsonForm = {},
    isUiChanged = {},
    setIsUiChanged,
    setFormData,
  } = designContext
  let formData = status.formData || jsonForm.formData || {}
  let itemKey = getRuleUpdateValueTarget(action, target)
  if (!itemKey) return undefined

  let ui = getCurrentUi(itemKey, jsonForm.schema, jsonForm.uischema)
  if (!ui?.key && !ui?.name) return undefined

  let value
  if (ui.uiType === 'widget') {
    value = updateRuleWidgetValue(
      formData,
      ui,
      status.listItem,
    )
  } else {
    value = status.listItem
      ? objectPath.get(status.listItem, ui.name)
      : objectPath.get(formData, ui.name)
    objectPath.set(formData, itemKey, value)
    objectPath.set(formData, ui.name, value)
  }

  objectPath.set(isUiChanged, itemKey, {
    isRender: true,
    ...getRuleUpdateValueStatus(status),
  })
  if (setFormData) setFormData(formData)
  if (setIsUiChanged) setIsUiChanged(isUiChanged)

  return {
    key: itemKey,
    value,
  }
}
